<template>
  <div class="share_img">
    <img
      class="share_img_item"
      :src="topImgUrl"
      alt="top"
      @load="onImgLoad"
      @error="onImgError"
    />
    <div style="justify-content: center;background-color: #31435b;    height: 100px;
    margin-top: -16px;">
        <button class="goto_btn" @click="openForm">立即占席 →</button>
        <div style="text-align: center;">
        <span style="color: white;font-size: 12px;text-align: center;">↓ 下滑，先看看你适不适合、这场闭门会值不值得来</span>
        </div>
    </div>
    <img
      class="share_img_item"
      :src="midImgUrl"
      alt="mid"
      @load="onImgLoad"
      @error="onImgError"
    />

    <!-- 表单 -->
    <div v-show="showForm" ref="formRef" class="form_wrap">
      <div class="countdown_wrap">
        <div class="countdown_tag">现在就占席</div>
        <div class="countdown_title">限20席·领《单院运营与回本测算手册》</div>
        <div class="countdown_sub">审核通过即锁定席位,免费参会,先到先得。</div>
        <div class="countdown_box">
          <div class="cd_item">
            <div class="cd_num">{{ countdown.d }}</div>
            <div class="cd_unit">天</div>
          </div>
          <div class="cd_sep">:</div>
          <div class="cd_item">
            <div class="cd_num">{{ countdown.h }}</div>
            <div class="cd_unit">时</div>
          </div>
          <div class="cd_sep">:</div>
          <div class="cd_item">
            <div class="cd_num">{{ countdown.m }}</div>
            <div class="cd_unit">分</div>
          </div>
          <div class="cd_sep">:</div>
          <div class="cd_item">
            <div class="cd_num">{{ countdown.s }}</div>
            <div class="cd_unit">秒</div>
          </div>
        </div>
      </div>
      <el-form
        ref="applyForm"
        :model="applyForm"
        :rules="applyRules"
        label-position="top"
        class="apply_form"
      >
        <div class="form_row">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="applyForm.name" placeholder="您的称呼" />
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="applyForm.phone" placeholder="11位手机号" maxlength="11" />
          </el-form-item>
        </div>
        <el-form-item label="所在城市" prop="city">
          <el-input v-model="applyForm.city" placeholder="如: 江苏 苏州" />
        </el-form-item>
        <el-form-item label="身份 / 行业" prop="industry">
          <el-select v-model="applyForm.industry" placeholder="请选择" :popper-append-to-body="false">
            <el-option label="医疗设备/耗材经销商" value="医疗设备/耗材经销商" />
            <el-option label="医药代表/药企区域经理" value="医药代表/药企区域经理" />
            <el-option label="医院后勤/物业/陪护承包商" value="医院后勤/物业/陪护承包商" />
            <el-option label="共享设备运营商(轮椅/陪护床/充电宝等)" value="共享设备运营商(轮椅/陪护床/充电宝等)" />
            <el-option label="康复/护理设备代理" value="康复/护理设备代理" />
            <el-option label="医院改造/家具供应商" value="医院改造/家具供应商" />
            <el-option label="其他（有医院资源）" value="其他（有医院资源）" />
          </el-select>
        </el-form-item>
        <div class="form_row">
          <el-form-item label="可投入资金" prop="fund">
            <el-select v-model="applyForm.fund" placeholder="请选择" :popper-append-to-body="false">
              <el-option label="50万以下" value="50万以下" />
              <el-option label="50-100万" value="50-100万" />
              <el-option label="100-300万" value="100-300万" />
              <el-option label="300万以上" value="300万以上" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否有医院资源" prop="hasHospital">
            <el-select v-model="applyForm.hasHospital" placeholder="请选择" :popper-append-to-body="false">
              <el-option label="有(已对接医院)" value="有" />
              <el-option label="有(待对接中)" value="待对接中" />
              <el-option label="暂无明显资源" value="暂无明显资源" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="想先验证的问题(选填)" prop="question">
          <el-input
            v-model="applyForm.question"
            type="textarea"
            :rows="2"
            placeholder="如: 我们县医院适不适合、回本要多久"
          />
        </el-form-item>
                <div class="form_row">
          <el-form-item label="座享总部邀约人" prop="sales_name">
            <el-select v-model="applyForm.sales_name" placeholder="请选择或输入" :popper-append-to-body="false" filterable allow-create default-first-option>
              <el-option label="座享总部-王琳" value="王琳" />
              <el-option label="座享总部-陈红" value="陈红" />
              <el-option label="座享总部-韩素萍" value="韩素萍" />
              <el-option label="座享总部-苏静静" value="苏静静" />
              <el-option label="座享总部-钱欣怡	" value="钱欣怡" />
              <el-option label="座享总部-余梦瑶	" value="余梦瑶" />
              <el-option label="座享总部-叶彩杰	" value="叶彩杰" />
            </el-select>
          </el-form-item>
        </div>
        <el-button
          type="danger"
          class="submit_btn"
          :loading="submitting"
          @click="submitForm"
        >
          提交报名 · 锁定席位
        </el-button>
      </el-form>
      <div class="tips">
        · 参会不收费,免费报名,审核通过后锁定席位。<br />
        · 本期仅 20 席,先到先得。<br />
        · 闭门邀约制,谢绝空降。
      </div>
    </div>
    <img
      class="share_img_item"
      :src="bottomImgUrl"
      alt="bottom"
      @load="onImgLoad"
      @error="onImgError"
    />
    <div v-if="imgLoading" class="loading_mask">图片加载中...</div>
    <!-- 右上角悬浮按钮 -->
    <button class="float_btn" @click="openForm">立即占席</button>

    <div v-if="showShareGuide" class="share_guide" @click="showShareGuide = false">
      <div class="guide_box">
        <p>点击右上角 ··· 分享给好友</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ShareImg',
  data() {
    return {
      topImgUrl: 'https://zuoxiang.oss-cn-zhangjiakou.aliyuncs.com/adult/top.jpg',
      bottomImgUrl: 'https://zuoxiang.oss-cn-zhangjiakou.aliyuncs.com/adult/bottom.jpg',
      midImgUrl: 'https://zuoxiang.oss-cn-zhangjiakou.aliyuncs.com/adult/mid.jpg',
      imgLoading: true,
      showShareGuide: false,
      showForm: true,
      submitting: false,
      applyForm: {
        name: '',
        phone: '',
        city: '',
        industry: '医疗设备/耗材经销商',
        fund: '50万以下',
        hasHospital: '有',
        question: '',
        sales_name: ''
      },
      applyRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的11位手机号',
            trigger: 'blur'
          }
        ],
        city: [{ required: true, message: '请输入所在城市', trigger: 'blur' }],
        industry: [{ required: true, message: '请选择身份/行业', trigger: 'change' }],
        fund: [{ required: true, message: '请选择可投入资金', trigger: 'change' }],
        hasHospital: [{ required: true, message: '请选择是否有医院资源', trigger: 'change' }]
      },
      // 倒计时截止时间 2026-11-06 13:00:00
      deadline: new Date('2026-11-06 13:00:00').getTime(),
      timer: null,
      countdown: { d: '00', h: '00', m: '00', s: '00' }
    }
  },
  mounted() {
    if (this.$route.query.top) {
      this.topImgUrl = this.$route.query.top
    }
    if (this.$route.query.bottom) {
      this.bottomImgUrl = this.$route.query.bottom
    }
    this.startCountdown()
    // this.initWxShare()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    pad(n) {
      return n < 10 ? '0' + n : '' + n
    },
    startCountdown() {
      const tick = () => {
        const now = Date.now()
        let diff = this.deadline - now
        if (diff <= 0) {
          this.countdown = { d: '00', h: '00', m: '00', s: '00' }
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
          }
          return
        }
        const d = Math.floor(diff / 86400000)
        diff -= d * 86400000
        const h = Math.floor(diff / 3600000)
        diff -= h * 3600000
        const m = Math.floor(diff / 60000)
        diff -= m * 60000
        const s = Math.floor(diff / 1000)
        this.countdown = {
          d: this.pad(d),
          h: this.pad(h),
          m: this.pad(m),
          s: this.pad(s)
        }
      }
      tick()
      this.timer = setInterval(tick, 1000)
    },
    onImgLoad() {
      this.imgLoading = false
    },
    onImgError() {
      this.imgLoading = false
      console.error('长图加载失败')
    },
    isWeixinBrowser() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.includes('micromessenger')
    },
    loadWxSdk() {
      return new Promise((resolve, reject) => {
        if (window.wx) {
          resolve()
          return
        }
        const script = document.createElement('script')
        script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('JSSDK 加载失败'))
        document.head.appendChild(script)
      })
    },
    openForm() {
      this.showForm = true
      this.$nextTick(() => {
        const el = this.$refs.formRef
        if (el) {
          // 微信 webview 兼容方案：用 scrollTo 代替 scrollIntoView
          const top = el.getBoundingClientRect().top + window.pageYOffset - 10
          window.scrollTo({ top, behavior: 'smooth' })
        }
      })
    },
    submitForm() {
      this.$refs.applyForm.validate(async (valid, invalidFields) => {
        if (!valid) {
          // 收集所有未通过校验的字段提示
          const msgs = []
          const fieldLabels = {
            name: '姓名',
            phone: '手机号',
            city: '所在城市',
            industry: '身份/行业',
            fund: '可投入资金',
            hasHospital: '医院资源'
          }
          for (const key in invalidFields) {
            const label = fieldLabels[key] || key
            const tips = invalidFields[key].map((item) => item.message).join('、')
            msgs.push(label + ': ' + tips)
          }
          this.$alert(msgs.join('<br/>'), '请完善信息', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '我知道了',
            center: true,
            customClass: 'mobile-center-alert'
          })
          return
        }
        this.submitting = true
        try {
          const res = await axios.post(
            'https://htapi.zxznzy.com/project/h5_customer_info',
            this.applyForm
          )
          console.log('报名接口响应:', res.data)
          const code = res.data.code !== undefined ? res.data.code : res.data.status
          if (code === 200 || code === 1) {
            this.$alert(
              '稍后工作人员将致电确认号码属地为江苏无锡,请拨冗接听!',
              '报名成功',
              {
                confirmButtonText: '我知道了',
                center: true,
                customClass: 'mobile-center-alert',
                type: 'success'
              }
            )
            this.applyForm.name = ''
            this.applyForm.phone = ''
            this.applyForm.city = ''
            this.applyForm.industry = '医疗设备/耗材经销商'
            this.applyForm.fund = '50万以下'
            this.applyForm.hasHospital = '有'
            this.applyForm.question = ''
            this.applyForm.sales_name = ''
          } else {
            this.$message.warning(res.data.msg || res.data.message || '提交失败,请稍后重试')
          }
        } catch (err) {
          console.error('报名提交失败', err)
          this.$message.error('网络异常,请稍后重试')
        } finally {
          this.submitting = false
        }
      })
    },
    async initWxShare() {
    //   if (!this.isWeixinBrowser()) return
      try {
        await this.loadWxSdk()
        const url = window.location.href.split('#')[0]
        const res = await axios.get(
          'https://htapi.zxznzy.com/childh5/get_scan_code_share_img',
          { params: { url } }
        )
        console.log('签名接口原始响应:', res.data)
        // 兼容后端返回结构：可能是 { appId,... } 或 { code:200, data:{ appId,... } }
        const cfg = res.data.data && res.data.data.appId ? res.data.data : res.data
        console.log('使用的签名配置:', cfg)
        window.wx.config({
          debug: true,
          appId: cfg.appId,
          timestamp: cfg.timestamp,
          nonceStr: cfg.nonceStr,
          signature: cfg.signature,
          jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareAppMessage',
          'onMenuShareTimeline'
        ]
        })

        window.wx.ready(() => {
          const shareData = {
            title: this.$route.query.title || '座享乐舒 · 成人椅全量套餐',
            link: window.location.href.split('#')[0],
            imgUrl: this.topImgUrl
          }

          // 新版 API（微信 6.5+）
          window.wx.updateAppMessageShareData({
            ...shareData,
            desc: this.$route.query.desc || '扫码即享按摩+充电'
          })
          window.wx.updateTimelineShareData(shareData)

          // 兼容旧版微信
          window.wx.onMenuShareAppMessage({
            ...shareData,
            desc: this.$route.query.desc || '扫码即享按摩+充电'
          })
          window.wx.onMenuShareTimeline(shareData)
        })

        window.wx.error((res) => {
          console.error('微信JSSDK配置失败', res)
          alert('wx.config 失败: ' + res.errMsg)
        })
      } catch (error) {
        alert('配置失败:',error.message)
        console.error('获取微信配置失败', error)
      }
    }
  }
}
</script>

<style scoped>
.share_img {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}

.share_img_item {
  width: 100%;
  display: block;
}

.goto_btn {
  display: block;
  width: 90%;
  height: 44px;
  margin: 16px auto;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(90deg, #ff6a3d 0%, #ff3b3b 100%);
  border: none;
  border-radius: 22px;
  box-shadow: 0 4px 12px rgba(255, 59, 59, 0.35);
  letter-spacing: 1px;
  cursor: pointer;
}

.goto_btn:active {
  transform: scale(0.97);
}

.float_btn {
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 100;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(90deg, #ff6a3d 0%, #ff3b3b 100%);
  border: none;
  border-radius: 18px;
  box-shadow: 0 4px 12px rgba(255, 59, 59, 0.4);
  letter-spacing: 1px;
  cursor: pointer;
  animation: floatBreath 2.2s ease-in-out infinite;
}

.float_btn:active {
  animation-play-state: paused;
  transform: scale(0.95);
}

@keyframes floatBreath {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.12); }
  100% { transform: scale(1); }
}

.goto_btn {
  display: block;
  width: 80%;
  max-width: 280px;
  height: 44px;
  margin: 16px auto;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(90deg, #ff6a3d 0%, #ff3b3b 100%);
  border: none;
  border-radius: 22px;
  box-shadow: 0 4px 12px rgba(255, 59, 59, 0.35);
  letter-spacing: 1px;
  cursor: pointer;
}

.goto_btn:active {
  transform: scale(0.97);
}

.form_wrap {
  margin: -1px 0;
  padding: 20px 16px 24px;
  background: linear-gradient(180deg, #1e4a6e 0%, #2a5a82 100%);
  color: #fff;
  margin-left: 18px;
  margin-right: 18px;
}

.countdown_wrap {
  text-align: center;
  margin-bottom: 18px;
}

.countdown_tag {
  display: inline-block;
  padding: 4px 14px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 10px;
}

.countdown_title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
}

.countdown_sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 14px;
}

.countdown_box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.cd_item {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  padding: 6px 10px;
  min-width: 48px;
}

.cd_num {
  font-size: 22px;
  font-weight: 700;
  font-family: 'DIN', 'Helvetica Neue', Arial, sans-serif;
}

.cd_unit {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
}

.cd_sep {
  font-size: 20px;
  font-weight: 700;
  padding-bottom: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.apply_form {
  width: 100%;
}

.form_row {
  display: flex;
  gap: 12px;
}

.form_row .el-form-item {
  flex: 1;
}

.apply_form /deep/ .el-form-item {
  margin-bottom: 14px;
}

.apply_form /deep/ .el-form-item__label {
  color: #e0eaf2;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 4px;
}

.apply_form /deep/ .el-form-item__label::before {
  content: '';
}

.apply_form /deep/ .el-input__inner,
.apply_form /deep/ .el-textarea__inner,
.apply_form /deep/ .el-select .el-input__inner {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  color: #333;
}

.apply_form /deep/ .el-input__inner::placeholder,
.apply_form /deep/ .el-textarea__inner::placeholder {
  color: #bbb;
}

.apply_form /deep/ .el-textarea__inner {
  min-height: 60px !important;
}

.submit_btn {
  width: 100%;
  height: 48px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-top: 8px;
  background: linear-gradient(90deg, #ff6a3d 0%, #ff3b3b 100%) !important;
  border: none !important;
  border-radius: 24px;
  color: #fff;
}

.tips {
  margin-top: 16px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
}

.loading_mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  color: #999;
  font-size: 14px;
}

.share_guide {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

.guide_box {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #fff;
}

.guide_box p {
  font-size: 16px;
}
</style>

<style>
/* Element UI MessageBox 渲染到 body 根节点，必须放在非 scoped 里 */
.mobile-center-alert {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
}

.mobile-center-alert .el-message-box__header {
  text-align: center;
}

.mobile-center-alert .el-message-box__btns {
  text-align: center;
}
</style>